import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode
  loading?: boolean
  variant?: 'primary' | 'secondary' | 'danger' | 'quiet'
}

export function Button({ icon, loading = false, variant = 'secondary', children, disabled, className = '', ...props }: ButtonProps) {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={`button button-${variant} ${className}`.trim()}
      aria-busy={loading || undefined}
    >
      {icon}
      <span>{loading ? 'Aguarde...' : children}</span>
    </button>
  )
}
